import LocalizedStrings from 'react-localization';
import English from './en';

const LangConsts = { en: { ...English, } as const, } as const;

const Lang = new LocalizedStrings(LangConsts);

export default Lang;
